import { convertToFahrenheit, getWeatherTypeFromCode } from "../weatherUtil";

const WeatherRow = ({ weather: { date, maxTemperature, minTemperature, weatherCode }, isCelsius }) => {
    const dateFormatter = new Intl.DateTimeFormat("en-US", {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
    });
    
    const formatDate = (date) => dateFormatter.format(date);

    return (
        <div className="weather-card">
            <div className="weather-date">{formatDate(date)}</div>
            <div className="weather-temp">
                H: {isCelsius ? `${Math.round(maxTemperature)} °C` : `${Math.round(convertToFahrenheit(maxTemperature))} °F`} • 
                L: {isCelsius ? `${Math.round(minTemperature)} °C` : `${Math.round(convertToFahrenheit(minTemperature))} °F`}
            </div>
            <div className="weather-type">{getWeatherTypeFromCode(weatherCode)}</div>
        </div>
    );
};

export default WeatherRow;